import React, { Component } from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import ModalSubheader from "../../ui-building-blocks/modal/ModalSubheader";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import EventEmitter from "../../../services/event-emitter";
import NumberFormat from "react-number-format";
import HelpIconButtonWithTooltip from "../../ui-building-blocks/icons/HelpIconButtonWithTooltip";
import HelpIconButton from "../../ui-building-blocks/icons/HelpIconButton";
import SelectBox from "../ui-components/OPSelectBox";
import {
  batchRequest,
  postRequest,
  putRequest,
  getRequest
} from "../../../api/ApiService";
import { logError } from "../../../services/utils";
import Loader from "react-loaders";
import { incrementUnacceptedDecisions } from "../../../api/SubmitDecisions";
import FontAwesome from "react-fontawesome";
import Fragment from "react-dot-fragment";
import ErrorInlineAlert from '../../alerts/errorInline';
import DecisionsAlert from '../../alerts/decisions';

import IconTableHelp from "../../../containers/assets/icon-table-help.svg";

bootstrapUtils.addStyle(Button, "save");
bootstrapUtils.addStyle(Button, "cancel");

const numberWithCommas = n =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const AVAILABLE_MACHINES_URL = `${process.env.REACT_APP_API_URL}static/machines/`;
const TEAM_MACHINES_URL = `${process.env.REACT_APP_API_URL}team/machines/`;
const PRODUCT_MANUFACTURES_URL = `${process.env.REACT_APP_API_URL}team/product_manufactures/`;
const PRICE_FORECASTS_URL = `${process.env.REACT_APP_API_URL}team/price_forecasts/`;
const MAX_ALLOWED_URL = `${process.env.REACT_APP_API_URL}team/product_manufactures/get_max_allowed/`;
const FACTORIES_URL = `${process.env.REACT_APP_API_URL}team/factories/`;

class ProduceProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showError: false,
      errorText: "",
      show: false,
      available_machines: [],
      team_machines: [],
      product_manufactures: [],
      machines: {},
      price_forecasts: [],
      max_units: {},
      products: [],
      units: {},
      loading_set: {},
      factory: 0,
      loading: true,
      errorTitle: null,
      errorMessage: null,
      showAwailableCapacityModal: false,
      availableCapacityInfoText: '',
      infoAlert: false,
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  showInfoAlert = () => {
    this.setState({
      infoAlert: true
    });
  };

  hideInfoAlert = () => {
    this.setState({
      infoAlert: false
    });
  };

  showError = (errorTitle, errorMessage) => {
    this.setState({
      errorTitle,
      errorMessage,
    }, () => {
      this.hideError();
    });
  }

  hideError = () => {
    setTimeout(() => {
      this.setState({
        errorTitle: null,
        errorMessage: null,
      });
    }, 5000);
  }

  componentDidMount() {
    this.eventemitter.on("show-product-product-modal", this.showModal);
  }

  componentWillUnmount() {
    this.eventemitter.off("show-product-product-modal", this.showModal);
  }

  showModal = () => {
    const { products } = this.props;

    if (products.length === 0) {
      this.eventemitter.trigger("app-show-error", [
        "You have no products. For more information, please speak to Product Management."
      ]);
      return;
    }

    this.setState(
      {
        show: true
      },
      () => {
        this.fetchData();
      }
    );
  };

  hideModal = () => {
    this.setState({
      show: false
    });
  };

  getMaxUnits = (product, machine, units_produced) => {
    return postRequest(MAX_ALLOWED_URL).send({
      product,
      machine,
      units_produced: units_produced || 1
    });
  };

  loadMaxUnits = () => {
    const { products } = this.props;
    const { product_manufactures, units } = this.state;

    let max_units = {};
    let requests = [];

    products.forEach(product => {
      const { product_id } = product;

      let units_produced = product.units_produced;
      if (product_id in units) {
        units_produced = units[product_id];
      }

      const obj = product_manufactures.find(i => i.product === product_id);
      if (obj) {
        const { machine } = obj;
        if (machine > 0) {
          requests.push(this.getMaxUnits(product_id, machine, units_produced));
        } else {
          max_units[product_id] = 0;
        }
      } else {
        max_units[product_id] = 0;
      }
    });

    if (requests.length === 0) {
      this.setState({
        max_units,
        loading: false
      });
      return;
    }

    Promise.all(requests)
      .then(res => {
        res.forEach(item => {
          const { max_allowed } = item.body;

          let product_id = parseInt(item.req._data.product, 10);
          if (isNaN(product_id)) {
            product_id = 0;
          }

          if (product_id > 0) {
            max_units[product_id] = max_allowed;
          }
        });

        this.setState({
          max_units,
          loading: false
        });
      })
      .catch(err => {
        const errUnitsProduced = err.response.body.units_produced;
        if (errUnitsProduced) {
          if (errUnitsProduced[0].indexOf('Max allowed') !== -1) {
            let product_id = parseInt(err.response.req._data.product, 10);
            max_units[product_id] = errUnitsProduced[0].match(/\d+/)[0];
            this.setState({
              max_units,
              loading: false
            });
          }
        }
        logError(err, "ProduceProduct", "loadMaxUnits");
      });
  };

  updateMaxUnits = product_id => {
    const { products } = this.props;
    const { product_manufactures, machines, units } = this.state;
    const max_units = { ...this.state.max_units };
    const product = products.find(i => i.product_id === product_id);

    let machine = 0;
    const obj = product_manufactures.find(i => i.product === product_id);
    if (obj) {
      machine = obj.machine;
    } else if (product_id in machines) {
      machine = machines[product_id];
    }

    let units_produced = product.units_produced;
    if (product_id in units) {
      units_produced = units[product_id];
    }

    if (machine === 0) {
      max_units[product_id] = 0;
      this.setState({
        max_units
      });
      return;
    }

    this.getMaxUnits(product_id, machine, units_produced)
      .then(res => {
        max_units[product_id] = res.body.max_allowed;

        this.setState({
          max_units
        });
      })
      .catch(err => {
        const errUnitsProduced = err.response.body.units_produced;
        if (errUnitsProduced) {
          if (errUnitsProduced[0].indexOf('Max allowed') !== -1) {
            let product_id = parseInt(err.response.req._data.product, 10);
            max_units[product_id] = errUnitsProduced[0].match(/\d+/)[0];
            this.setState({
              max_units
            });
          }
        }
        logError(err, "ProduceProduct", "updateMaxUnits");
      });
  };

  fetchData() {
    const joinRequest = batchRequest([
      AVAILABLE_MACHINES_URL,
      TEAM_MACHINES_URL,
      PRODUCT_MANUFACTURES_URL,
      PRICE_FORECASTS_URL,
      FACTORIES_URL,
      `${process.env.REACT_APP_API_URL}team/products/`
    ]);

    joinRequest
      .then(res => {
        if (
          res[0].statusCode !== 200 ||
          res[1].statusCode !== 200 ||
          res[2].statusCode !== 200 ||
          res[3].statusCode !== 200 ||
          res[4].statusCode !== 200
        ) {
          throw res;
        }

        const available_machines = res[0].body;
        const team_machines = res[1].body.filter(team_machine => !team_machine.sold_in_round);
        const product_manufactures = res[2].body;
        const price_forecasts = res[3].body;
        const factories = res[4].body;
        const factory = factories.length > 0 ? factories[0].id : 0;
        const products = res[5].body;

        this.setState(
          {
            available_machines,
            team_machines,
            product_manufactures,
            price_forecasts,
            factory,
            units: {},
            loading_set: {},
            machines: {},
            products
          },
          () => {
            this.loadMaxUnits();
          }
        );
      })
      .catch(err => {
        logError(err, "ProduceProduct", "fetchData");
      });
  }

  updateMachine = e => {
    const input = e.target;

    let value = Number(input.value);
    if (typeof value !== "number") {
      value = 0;
    }

    let { productId } = input.dataset;
    productId = parseInt(productId, 10);
    if (isNaN(productId)) {
      productId = 0;
    }

    let product_manufactures = [...this.state.product_manufactures];
    let machines = { ...this.state.machines };
    let units = { ...this.state.units };

    let objIndex = product_manufactures.findIndex(i => i.product === productId);
    if (objIndex >= 0) {
      let obj = product_manufactures[objIndex];
      if (obj.machine !== value) {
        product_manufactures[objIndex].machine = value;

        this.setState(
          {
            product_manufactures,
            units: { ...units, [productId]: units[productId] > 0 ? units[productId] : 1 }
          },
          () => {
            this.updateMaxUnits(productId);
          }
        );
      }
    } else {
      machines[productId] = value;

      this.setState(
        {
          machines,
          units: { ...units, [productId]: units[productId] > 0 ? units[productId] : 1 }
        },
        () => {
          this.updateMaxUnits(productId);
        }
      );
    }
  };

  updateUnits = (e, nonFormattedValue) => {
    const input = e.target;

    let value = nonFormattedValue
      ? nonFormattedValue.floatValue
      : Number(input.value);
    if (typeof value !== "number") {
      value = 0;
    }

    let { productId } = input.dataset;
    productId = parseInt(productId, 10);
    if (isNaN(productId)) {
      productId = 0;
    }

    let units = { ...this.state.units };
    units[productId] = value;

    this.setState({
      units
    });
  };

  isLoading = product_id => {
    const { loading_set } = this.state;

    if (product_id in loading_set) {
      return loading_set[product_id];
    }

    return false;
  };

  updateLoading = (product_id, value) => {
    let loading_set = { ...this.state.loading_set };
    loading_set[product_id] = value;

    this.setState({
      loading_set
    });
  };

  setModalLoading = () => {
    this.setState({
      loading: true
    });
  }

  updateError = (showError, errorText) => {
    this.setState({
      showError,
      errorText
    });
  };

  submitRequest = (
    product_id,
    machine,
    units_produced,
    product_manufacture
  ) => {
    const { factory } = this.state;
    const data = {
      factory,
      machine,
      product: parseInt(product_id, 10),
      units_produced
    };

    let url = `${process.env.REACT_APP_API_URL}team/product_manufactures/`;

    if (product_manufacture) {
      url += `${product_manufacture.id}/`;

      return putRequest(url).send(data);
    }

    return postRequest(url).send(data);
  };

  showPopup = units => {
    this.eventemitter.trigger("coaching-feedback", [
      "Inventory Management",
      <Fragment>
        Whoa! You’re only producing {numberWithCommas(units)} units? How many
        image sensors are customers demanding again? You should double check
        customer demand in the &lt;
        <a href="/ceo/analysis/market" target="_blank">
          customer analysis
        </a>
        &gt; page and reconsider producing more units if you only have a few or
        no units in inventory.
      </Fragment>
    ]);
  };

  showPopup2 = () => {
    this.eventemitter.trigger("coaching-feedback", [
      "Not Released Yet",
      <Fragment>
        Whoa! This product won’t be released from design this year and therefore
        you won’t be able to produce units.
        <br />
        <br />
        For more details on this product’s release date, please follow up with
        your Head of Product who created the product. S/he has the power to
        modify its features if you want to produce it this year.
      </Fragment>
    ]);
  };

  submit = product_id => {
    const { products, reloadData } = this.props;
    const { product_manufactures, units, max_units, machines } = this.state;
    const product = products.find(i => i.product_id === product_id);

    if (!product) {
      return;
    }

    let machine = 0;
    let product_manufacture = product_manufactures.find(
      i => i.product === product_id
    );
    if (product_manufacture) {
      machine = product_manufacture.machine;
    } else if (product_id in machines) {
      machine = machines[product_id];
    }

    let units_produced = product.units_produced;
    if (product_id in units) {
      units_produced = units[product_id];
    }

    if (!units_produced) {
      this.showError('Value Must Be At Least 1', 'You have to input at least 1 unit for production in order to produce units');
      return;
    }

    this.updateError(false, "");
    this.updateLoading(product_id, true);
    this.setModalLoading();

    this.submitRequest(product_id, machine, units_produced, product_manufacture)
      .then(res => {
        const { units_produced, months_to_produce } = res.body;
        if (units_produced <= 100000) {
          this.showPopup(units_produced);
        } else if (months_to_produce === 0) {
          this.showPopup2();
        }

        const foundProduct = products.find(i => i.product_id === product_id);

        this.props.showSuccessMessage(`${units_produced.toLocaleString('en-US')} units of Product ${foundProduct.product_name} is now scheduled to be manufactured`);
        incrementUnacceptedDecisions("operations");
        this.updateLoading(product_id, false)
        reloadData();
        this.fetchData();
      })
      .catch(err => {
        this.updateLoading(product_id, false);
        if (
          err.response.status === 400 &&
          "machine" in err.response.body &&
          err.response.body["machine"].length > 0
        ) {
          this.updateLoading(product_id, false);
          this.updateError(true, err.response.body["machine"][0]);
          return;
        } else {
          if (machine === 0) {
            this.updateError(true, "Please make machine selection!");
            return;
          }

          if (units_produced < 1) {
            this.updateError(
              true,
              `${product.product_name}'s units cannot be lower then 1`
            );
            return;
          }

          let max_allowed = 0;
          if (product_id in max_units) {
            max_allowed = max_units[product_id];
          }

          const p = this.state.products.find(i => i.id === product_id);
          if (!p || p.months_available_to_produce === 0) {
            this.showError('Error | Product Not Yet Released From Design', 'You cannot manufacture units of this product until it’s released from product design. To modify the release date, please follow up with your Product Manager.');
            return;
          }

          if (units_produced > max_allowed) {
            this.showError('Error | No More Available Capacity', 'You cannot manufacture more than your available capacity. Please modify the no. of units or consider a production line with greater capacity.');
            return;
          }
        }

        logError(err, "ProduceProduct", "submit");
      });
  };

  onRemoveOperation = (e, product_id) => {
    this.setModalLoading();
    this.props.onRemoveOperation(e, product_id, () => {
      this.props.reloadData();
      this.fetchData();
    });
  };

  onAvailableCapacityQuestionClick = () => {
    const { currentRound } = this.props;
    getRequest(`${process.env.REACT_APP_API_URL}team/products/?round_number=${currentRound}`)
      .then(res => {
        const teamProduct = res.body[0];
        let availableCapacityInfoText = '';
        if (teamProduct.months_available_to_produce === 0) {
          availableCapacityInfoText = <span><b>Your product’s release date is beyond a year (round):</b> If you want the release date to be within this year, navigate to product decision page and adjust your product features.</span>;
        } else {
          availableCapacityInfoText = <span><b>Your product is either still in the design phase or has reached maximum production with this machine. :</b>  Check your product page for the release date. If it's not a future date, you've already produced the maximum units. </span>;
        }

        this.setState({
          showAwailableCapacityModal: true,
          availableCapacityInfoText
        });
      })
      .catch(err => { });
  }

  onAvailableCapacityInfoHide = () => {
    this.setState({
      showAwailableCapacityModal: false
    });
  }

  render() {
    const {
      showError,
      errorText,
      show,
      loading,
      available_machines,
      team_machines,
      product_manufactures,
      price_forecasts,
      max_units,
      units,
      machines,
      errorTitle,
      errorMessage,
      showAwailableCapacityModal,
      availableCapacityInfoText,
      infoAlert
    } = this.state;
    const { products } = this.props;
    const hideModal = this.hideModal;

    return (
      <Modal
        show={show}
        onHide={hideModal}
        dialogClassName="modal-dialog-biggest"
      >
        {
          showAwailableCapacityModal &&
          <DecisionsAlert
            type="info"
            title='Your Available Capacity is zero. Here’s why'
            message={availableCapacityInfoText}
            buttonText="Done"
            onHide={this.onAvailableCapacityInfoHide}
            overlayStylings={'border-radius: 30px;'}
            modalStylings={'top: 50%; transform: translateY(-50%);'}
          />
        }
        {
          infoAlert && (
            <DecisionsAlert
              type="info"
              title="Available Capacity"
              message="Refers to the maximum number of units that can be produced."
              buttonText="Done"
              onHide={this.hideInfoAlert}
              modalStylings={'top: 50%; transform: translateY(-50%);'}
            />
          )
        }
        <Modal.Header>
          <Modal.Title
            bsClass="modal-title title-light-blue"
            componentClass={ModalSubheader}
            subheader="FAB FACILITY"
          >
            Foundry
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showError === true && (
            <div className="row">
              <div className="col-xs-12">
                <Alert bsStyle="danger">{errorText}</Alert>
              </div>
            </div>
          )}
          {errorTitle && errorMessage && (
            <ErrorInlineAlert
              title={errorTitle}
              message={errorMessage}
            />
          )}
          <div className="table-responsive mt-15">
            <h4 className="mb-20 title-blue">Production Run</h4>
            <table className="table">
              {loading === false && (
                <thead>
                  <tr className="border-none">
                    <th className="text-center">
                      <b className="title-black">Products</b>
                    </th>
                    <th className="text-center">
                      <b className="title-black">Production Line</b>
                    </th>
                    <th className="text-center">
                      <b className="title-black">Units</b>
                    </th>
                    <th className="text-center">
                      <b className="title-black">Sales Forecast</b>
                    </th>
                    <th className="text-center">
                      <b className="title-black">Available Capacity</b>
                      <img alt="icon help" src={IconTableHelp} style={{ marginLeft: 4, cursor: 'pointer' }} onClick={this.showInfoAlert} />
                    </th>
                    <th className="text-center">
                      <b className="title-black">Actions</b>
                    </th>
                  </tr>
                </thead>
              )}
              <tbody>
                {loading === true ? (
                  <tr className="border-none">
                    <td className="text-center loader-inline" colSpan="6">
                      <Loader type="ball-scale-ripple" active={true} />
                    </td>
                  </tr>
                ) : (
                  products.map((product, i) => {
                    const { product_id, product_name } = product;
                    const is_loading = this.isLoading(product_id);
                    let machine_id = 0;
                    const product_manufacture = product_manufactures.find(
                      i => i.product === product_id
                    );
                    if (product_manufacture) {
                      machine_id = product_manufacture.machine;
                    } else if (product_id in machines) {
                      machine_id = machines[product_id];
                    }
                    let forecast = 0;
                    const price_forecast = price_forecasts.find(
                      i => i.product === product_id
                    );
                    if (price_forecast) {
                      forecast = price_forecast.forecast;
                    }
                    let max_units_value = 0;
                    if (product_id in max_units) {
                      max_units_value = max_units[product_id];
                    }
                    let units_produced = product.units_produced;
                    if (product_id in units) {
                      units_produced = units[product_id];
                    }

                    const actionsStyle = {
                      width: "135px",
                      verticalAlign: "middle"
                    };
                    const removeBtnStyle = {
                      marginLeft: "10px",
                      top: "2px"
                    };
                    const can_remove =
                      product.units_produced > 0 ? true : false;

                    return (
                      <tr className="border-none" key={i}>
                        <td className="text-center">Product {product_name}</td>
                        <td className="text-center">
                          <SelectBox
                            available_machines={available_machines}
                            team_machines={team_machines}
                            productId={product_id}
                            name="machine"
                            value={machine_id}
                            onChange={this.updateMachine}
                            isDisabled={can_remove}
                          />
                        </td>
                        <td className="text-center">
                          <NumberFormat
                            name="units_produced"
                            data-product-id={product_id}
                            value={units_produced}
                            thousandSeparator=","
                            onChange={this.updateUnits}
                          />
                        </td>
                        <td className="text-center">
                          <NumberFormat
                            value={forecast}
                            thousandSeparator=","
                            displayType="text"
                          />
                          {forecast === 0 && (
                            <HelpIconButtonWithTooltip
                              tooltipContent="Marketing has not made any forecast for sales yet. Please coordinate with Marketing if you want sales forecast numbers."
                              iconSize="sm"
                              category="Product Units Sales Forecast"
                            />
                          )}
                        </td>
                        <td className="text-center">
                          <NumberFormat
                            value={max_units_value}
                            thousandSeparator=","
                            displayType="text"
                          />
                          {max_units_value === 0 && machine_id > 0 && (
                            <HelpIconButton
                              onClick={this.onAvailableCapacityQuestionClick}
                              iconSize="sm"
                              category="Produce Units Max Units"
                            />
                          )}
                        </td>
                        <td className="text-center" style={actionsStyle}>
                          <Button
                            bsStyle="cancel"
                            disabled={is_loading}
                            onClick={() => this.submit(product_id)}
                          >
                            {is_loading === true ? "Loading..." : "Update"}
                          </Button>
                          {can_remove === true && (
                            <a
                              href="/#"
                              className="remove-operation"
                              onClick={e =>
                                this.onRemoveOperation(e, product_id)
                              }
                              style={removeBtnStyle}
                            >
                              <FontAwesome name="trash-o" />
                            </a>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer bsClass="modal-footer op-decision-modal-footer">
          <Button bsStyle="save" onClick={hideModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ProduceProduct;



// WEBPACK FOOTER //
// ./src/components/operations/helper-components/produce-product.js